<footer id="footer" role="contentinfo" class="site-footer">
	<div class="background-wrapper">
		<div class="footer-content-navigation">
			<div class=" wrapper wrap">
				<div class="row">
					<div class="col-md-4">
						<div class="footer-nav-secondary">
							<ul>
								<li>
									<a href="https://www.dorsetcouncil.gov.uk/footer/html-sitemap.aspx"
										target="">Sitemap</a>
								</li>
								<li>
									<a href="https://www.dorsetcouncil.gov.uk/footer/about-this-website" target="">About
										this website</a>
								</li>
								<li>
									<a href="https://www.dorsetcouncil.gov.uk/contact/contacts" target="">Contact us</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-md-4">
						<div class="footer-nav-secondary">
							<ul>
								<li>
									<a href="https://www.dorsetcouncil.gov.uk/w/dorset-council-s-commercial-waste-and-strategy-privacy-notice"
										target="">Privacy Statement</a>
								</li>
								<li>
									<a href="https://www.dorsetcouncil.gov.uk/w/bookinglab-accessibility-statement"
										target="">Accessibility Statement</a>
								</li>
								<li>
									<a [routerLink]="['cookies']" target="">Cookies</a>
								</li>
								<li>
									<a href="https://www.dorsetcouncil.gov.uk/footer/terms-and-conditions"
										target="">Terms and Conditions</a>
								</li>
								<li>
									<a href="https://translate.google.com/" target="_blank">Translate</a>
								</li>
								<li>
									<a href="https://dorsetcouncil.us1.list-manage.com/subscribe?u=c39535cf4f9d1ca66af8d2b44&amp;id=bc36c80975"
										target="_blank">E-newsletter sign up</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-md-4">
						<div class="footer-nav-social">
							<div class="follow-title">Follow us:</div>
							<ul>
								<li>
									<span class="icon-facebook-sign">
										<fa-icon [icon]="faSquareFacebook"
											style="color: white !important; z-index: 999;"></fa-icon>
										<a href="https://www.facebook.com/dorsetcounciluk" target="_blank">
											Facebook
										</a>
									</span>
								</li>
								<li>
									<span class="icon-sign-blank">
										<fa-icon [icon]="faSquare"
											style="color: white !important; z-index: 999;"></fa-icon>
										<a href="https://x.com/dorsetcounciluk" target="_blank">
											X
										</a>
									</span>
								</li>
								<li>
									<span class="icon-youtube-play">
										<fa-icon [icon]="faYoutube"
											style="color: white !important; z-index: 999;"></fa-icon>
										<a href="https://www.youtube.com/c/dorsetcounciluk" target="_blank">
											YouTube
										</a>
									</span>
								</li>
								<li>
									<span class="icon-instagram">
										<fa-icon [icon]="faInstagram"
											style="color: white !important; z-index: 999;"></fa-icon>
										<a href="https://www.instagram.com/dorsetcounciluk/" target="_blank">
											Instagram
										</a>
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-2">
						<div class="footer-logo">
							<a class="logo custom-logo" href="https://www.dorsetcouncil.gov.uk"
								title="Go to Dorset Council">
								<img alt="Dorset Council" style="max-height: 80px; margin: 20px;"
									src="https://www.dorsetcouncil.gov.uk/image/layout_set_logo?img_id=3219019&amp;t=1749740840898">
							</a>
						</div>
					</div>
					<div class="col-md-10">
						<p class="footer-rights">Copyright © 2025 Dorset Council</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>